module.exports = __webpack_public_path__ + "components/carousel-popular-mountains/static/generic-bg--2-914f91f872023f8868828a1c7757a476.jpg";